import { useContext, useEffect, useState } from "react";
import { UserData } from "../../../Context/DataContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import styles from "./styles/inheritance.module.css";

import lawyer_icon from "./styles/img/laywer_icon.svg";
import useWindowDimensions from "../../Footer/footer";
import EditTrustee from "../Edit Trustee/EditTrustee";
import { formatUrl } from "../../../Utils/formatUrl";
import SharedFilesModal from "../Partner Files/SharedFilesModal";

export default function PromotionData() {
  const userData = UserData();
  const { height, width } = useWindowDimensions();
  const [modal, setModal] = useState(false);
  let userValidationData = userData?.userValidationData;
  const websiteCurrentLang = useContext(LanguageContext).language;
  if (!userValidationData.promotion_name) {
    userValidationData = userData.promotionData;
  }

  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  const [previewedLogo, setPreviewedLogo] = useState(undefined);
  const trustee = userData.UserData.trustees.filter(
    (x) => x.name === userValidationData.promotion_name
  )[0];
  const closeModal = () => {
    setModal(null);
  };
  const openModal = () => {
    /*
      A partner gets the FILES, and nothing else.

      The advisor behind this card is matched against the CUSTOMER's
      advisors by name, so opening it here would put somebody else's
      record on screen in edit mode. But the card is also the only way a
      partner reaches the files their customer uploaded for them, and
      refusing the click outright left them with no way in at all.

      So the same click opens the file panel by itself -- see
      Partner Files/SharedFilesModal.
    */
    if (userData.partnerReadOnly) {
      setModal(
        <SharedFilesModal
          partnerName={userValidationData.promotion_name}
          onClose={closeModal}
        />
      );
      return;
    }
    if (trustee) {
      setModal(
        <EditTrustee
          toEdit={trustee}
          onClose={closeModal}
          /*
            Not here. This opens the advisor behind the sponsor's card, and
            on that card "share this trusted advisor with {partner}" would
            be asking the customer to share the partner with themselves.
            The section belongs on the Trusted Advisors page, where the
            same modal is about managing that advisor.
          */
          showPartnerSharing={false}
          /*
            And this is where it DOES belong: the card is the partner, so
            "share files securely with them" is the question this screen
            is for.
          */
          showPartnerFiles={true}
        />
      );
    }
  };
  // console.log("xxxxxxxxxxxxxxxxxxxxxxxx");
  // console.log(trustee);
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  useEffect(() => {
    if (
      userValidationData.promotion_logo &&
      userValidationData.promotion_logo.length > 0
    ) {
      let extension = userValidationData.promotion_logo[0];
      if (extension === "/") extension = ".jpg";
      else if (extension === "i") extension = ".png";

      const imageUrl = `data:image/${extension};base64,${userValidationData.promotion_logo}`;
      setPreviewedLogo(imageUrl);
    }
  }, [userValidationData.promotion_logo]);

  return (
    <>
      <div
        className={styles.promotionContainer}
        style={
          width < 1200
            ? {
                position: "relative",
                // margin: "0 auto",
                // marginBottom: "50px",
                left: "0",
                zIndex: 1,
              }
            : { zIndex: 1 }
        }
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "5px",
              width: "100%",
            }}
          >
            <p
              style={{ fontSize: "12px", fontWeight: "500" }}
              className={styles.promotionContainerTitle}
            >
              {userValidationData.promotion_presented_as}
            </p>
            <p className={styles.promotionContainerName}>
              {userValidationData.promotion_name}
            </p>
          </div>
          {/* <img
          src={lawyer_image}
          alt="lawyer"
          style={{
            alignSelf: "flex-start",
            width: "60px",
            height: "60px",
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
        /> */}
          {previewedLogo && (
            <div
              style={{
                borderRadius: "50%",
                alignSelf: "flex-start",
                width: "80px",
                height: "80px",
                position: "absolute",
                top: "10px",
                right: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "white",
              }}
            >
              <img
                src={previewedLogo}
                alt="lawyer"
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                }}
              ></img>
            </div>
          )}
        </div>
        {userValidationData.promotion_email &&
          userValidationData.promotion_email.length > 0 && (
            <div className={styles.promotionContainerItem}>
              <img
                style={{
                  scale: "1.2",
                  marginBottom: "2px",
                }}
                src={lawyer_icon}
                alt="icon"
              />
              <p
                style={{
                  width: "70%",
                }}
                className={styles.promotionContainerTitle}
              >
                {userValidationData.promotion_email}
              </p>
            </div>
          )}
        {userValidationData.promotion_phone_number &&
          userValidationData.promotion_phone_number.length > 0 && (
            <div className={styles.promotionContainerItem}>
              <img
                style={{
                  scale: "1.2",
                  marginBottom: "2px",
                }}
                src={lawyer_icon}
                alt="icon"
              />
              <p className={styles.promotionContainerTitle}>
                {userValidationData.promotion_phone_number}
              </p>
            </div>
          )}
        {/* TODO: physical address */}
        {userValidationData.promotion_address &&
          userValidationData.promotion_address?.length > 0 && (
            <div className={styles.promotionContainerItem}>
              <img
                style={{
                  scale: "1.2",
                  marginBottom: "2px",
                }}
                src={lawyer_icon}
                alt="icon"
              />
              <p className={styles.promotionContainerTitle}>
                {userValidationData.promotion_address}
              </p>
            </div>
          )}
        {userValidationData.website_url &&
          userValidationData.website_url?.length > 0 && (
            <div className={styles.promotionContainerItem}>
              <img
                style={{
                  scale: "1.2",
                  marginBottom: "2px",
                }}
                src={lawyer_icon}
                alt="icon"
              />
              <a
                style={{
                  cursor: "pointer",
                  color: "var(--color_blue)",
                  textDecoration: "underline",
                  marginBottom: "3px",
                }}
                href={formatUrl(userValidationData.website_url)}
                target="_blank"
                className={styles.promotionContainerTitle}
              >
                {userValidationData.website_url}
              </a>
            </div>
          )}

        {userValidationData.promotion_marketing &&
          userValidationData.promotion_marketing.length > 0 && (
            <div className={styles.promotionContainerItem}>
              <img
                style={{
                  scale: "1.2",
                  marginBottom: "2px",
                }}
                src={lawyer_icon}
                alt="icon"
              />
              <p
                style={{
                  whiteSpace: "wrap",
                  textOverflow: "unset",
                  overflow: "unset",
                  wordBreak: "break-word",
                }}
                className={styles.promotionContainerTitle}
              >
                {userValidationData.promotion_marketing}
              </p>
            </div>
          )}
        {/*
          The same door as "See More", in the place somebody looking for it
          would press.

          Gated on the same `trustee`: both open that advisor's record, and
          without one there is nothing to open -- a button that did nothing
          would be worse than no button. Hidden from a partner too, where
          this card is their OWN branding and the sentence would be
          addressed to themselves.

          Positioned rather than placed in flow: the card is absolutely
          positioned, so a sibling after it would land somewhere else
          entirely. `top: 100%` on a child sits it directly beneath, at the
          card's own width, whatever height the card has grown to.
        */}
        {(trustee || userData.partnerReadOnly) && (
          <button
            type="button"
            className={styles.promotionShareButton}
            onClick={openModal}
            title={`${dublicatedcontent.dublicatedText305} ${userValidationData.promotion_name}`}
          >
            <span className={styles.promotionShareButtonLabel}>
              {dublicatedcontent.dublicatedText305}
            </span>
            {/*
              The name is the part that truncates, not the sentence. Its own
              element so the words before it are never the thing that gets
              cut -- a button reading "Share File Securely W..." says
              nothing at all.
            */}
            <span className={styles.promotionShareButtonName}>
              {userValidationData.promotion_name}
            </span>
          </button>
        )}
        {(trustee || userData.partnerReadOnly) && (
          <p
            style={{
              marginLeft: "auto",
              marginRight: "0",
              textDecoration: "underline",
              color: "var(--color_blue)",
              cursor: "pointer",
              zIndex: "2",
              fontSize: "12px",
            }}
            onClick={() => {
              /*
                For a partner there is no advisor to require: the click
                opens the files their customer shared with them.
              */
              if (trustee || userData.partnerReadOnly) openModal();
            }}
          >
            {dublicatedcontent.seeMore}
          </p>
        )}
      </div>
      {<div style={{ position: "absolute", zIndex: "6" }}>{modal}</div>}
    </>
  );
}
